"use client";

import React from "react";
import dynamic from "next/dynamic";
import type { DynamicFlowBaseProps } from "@highereducation/supersonic-ui";
import { SearchFypPlacement } from "@/monarch/rules/searchFypEntry/types";

const SEARCH_FYP_SLOT_PLACEMENT: NonNullable<
  DynamicFlowBaseProps["placement"]
> = "belowTheFold";

const DynamicFlowWrapper = dynamic(
  () => import("@/components/DynamicFlowWrapper"),
  {
    ssr: false,
    loading: () => (
      <div
        className="min-h-[120px] animate-pulse rounded-xl bg-gray-200"
        role="status"
        aria-label="Loading learning path finder"
      />
    ),
  },
);

interface SearchFypEntryProps {
  placement: SearchFypPlacement;
  forcedFlowId?: string;
  jumpToStepId?: string;
  styleVariant?: "default" | "alt";
  isLoading?: boolean;
}

export default function SearchFypEntry({
  placement,
  forcedFlowId,
  jumpToStepId,
  styleVariant,
  isLoading = false,
}: SearchFypEntryProps) {
  if (isLoading) {
    return (
      <div
        className="min-h-[120px] animate-pulse rounded-xl bg-gray-200"
        data-testid="search-fyp-skeleton"
        role="status"
        aria-label="Loading learning path finder"
      />
    );
  }

  return (
    <div
      role="region"
      aria-labelledby={`search-fyp-heading-${placement}`}
      data-testid="search-fyp-entry"
    >
      <h2 id={`search-fyp-heading-${placement}`} className="sr-only">
        Find your learning path
      </h2>
      <DynamicFlowWrapper
        placement={SEARCH_FYP_SLOT_PLACEMENT}
        forcedFlowId={forcedFlowId}
        jumpToStepId={jumpToStepId}
        styleVariant={styleVariant}
      />
    </div>
  );
}
